<dialog class="dialog signatureDialog" id="addSignatureDialog" aria-labelledby="addSignatureDialogLabel">
  <span id="addSignatureDialogLabel" data-l10n-id="pdfjs-editor-add-signature-dialog-label"></span>
  <div id="addSignatureContainer" class="mainContainer">
    <div class="title">
      <span role="sectionhead" data-l10n-id="pdfjs-editor-add-signature-dialog-title" tabindex="0"></span>
    </div>
    <div role="tablist" id="addSignatureOptions">
      <button id="addSignatureTypeButton" type="button" role="tab" aria-selected="true"
        aria-controls="addSignatureTypeContainer" data-l10n-id="pdfjs-editor-add-signature-type-button"
        tabindex="0"></button>
      <button id="addSignatureDrawButton" type="button" role="tab" aria-selected="false"
        aria-controls="addSignatureDrawContainer" data-l10n-id="pdfjs-editor-add-signature-draw-button"
        tabindex="0"></button>
      <button id="addSignatureImageButton" type="button" role="tab" aria-selected="false"
        aria-controls="addSignatureImageContainer" data-l10n-id="pdfjs-editor-add-signature-image-button"
        tabindex="-1"></button>
    </div>
    <div id="addSignatureActionContainer" data-selected="type">
      <div id="addSignatureTypeContainer" role="tabpanel" aria-labelledby="addSignatureTypeContainer">
        <input id="addSignatureTypeInput" type="text" data-l10n-id="pdfjs-editor-add-signature-type-input" tabindex="0">
      </div>
      <div id="addSignatureDrawContainer" role="tabpanel" aria-labelledby="addSignatureDrawButton" tabindex="-1">
        <svg id="addSignatureDraw" xmlns="http://www.w3.org/2000/svg"
          aria-labelledby="addSignatureDrawPlaceholder"></svg>
        <span id="addSignatureDrawPlaceholder" data-l10n-id="pdfjs-editor-add-signature-draw-placeholder"></span>
        <div id="thickness">
          <div>
            <label for="addSignatureDrawThickness"
              data-l10n-id="pdfjs-editor-add-signature-draw-thickness-range-label"></label>
            <input type="range" id="addSignatureDrawThickness" min="1" max="5" step="1" value="1"
              data-l10n-id="pdfjs-editor-add-signature-draw-thickness-range" data-l10n-args='{ "thickness": 1 }'
              tabindex="0">
          </div>
        </div>
      </div>
      <div id="addSignatureImageContainer" role="tabpanel" aria-labelledby="addSignatureImageButton" tabindex="-1">
        <svg id="addSignatureImage" xmlns="http://www.w3.org/2000/svg"
          aria-labelledby="addSignatureImagePlaceholder"></svg>
        <div id="addSignatureImagePlaceholder">
          <span data-l10n-id="pdfjs-editor-add-signature-image-placeholder"></span>
          <label id="addSignatureImageBrowse" for="addSignatureFilePicker" tabindex="0">
            <a data-l10n-id="pdfjs-editor-add-signature-image-browse-link"></a>
          </label>
          <input id="addSignatureFilePicker" type="file">
        </div>
      </div>
      <div id="addSignatureControls">
        <div id="horizontalContainer">
          <div id="addSignatureDescriptionContainer">
            <label for="addSignatureDescInput" data-l10n-id="pdfjs-editor-add-signature-description-label"></label>
            <span id="addSignatureDescription" class="inputWithClearButton">
              <input id="addSignatureDescInput" type="text" data-l10n-id="pdfjs-editor-add-signature-description-input"
                tabindex="0">
              <button class="clearInputButton" type="button" tabindex="0" aria-hidden="true"></button>
            </span>
          </div>
          <!-- pdf.js 6.3 gives this button the shared .secondaryButton style; harmless on 6.2. -->
          <button id="clearSignatureButton" class="secondaryButton" type="button" data-l10n-id="pdfjs-editor-add-signature-clear-button"
            tabindex="0"><span data-l10n-id="pdfjs-editor-add-signature-clear-button-label"></span></button>
        </div>
        <div id="addSignatureSaveContainer">
          <input type="checkbox" id="addSignatureSaveCheckbox" checked="true">
          <label for="addSignatureSaveCheckbox" data-l10n-id="pdfjs-editor-add-signature-save-checkbox"></label>
          <span></span>
          <span id="addSignatureSaveWarning" data-l10n-id="pdfjs-editor-add-signature-save-warning-message"></span>
        </div>
      </div>
      <div id="addSignatureError" hidden="true" class="messageBar">
        <div>
          <div>
            <span id="addSignatureErrorTitle" class="title" data-l10n-id="pdfjs-editor-add-signature-image-upload-error-title"></span>
            <span id="addSignatureErrorDescription" class="description" data-l10n-id="pdfjs-editor-add-signature-image-upload-error-description"></span>
          </div>
          <button id="addSignatureErrorCloseButton" class="closeButton" type="button" tabindex="0"><span
              data-l10n-id="pdfjs-editor-add-signature-error-close-button"></span></button>
        </div>
      </div>
      <div class="dialogButtonsGroup">
        <button id="addSignatureCancelButton" type="button" class="secondaryButton" tabindex="0"><span
            data-l10n-id="pdfjs-editor-add-signature-cancel-button"></span></button>
        <button id="addSignatureAddButton" type="button" class="primaryButton" disabled tabindex="0"><span
            data-l10n-id="pdfjs-editor-add-signature-add-button"></span></button>
      </div>
    </div>
  </div>
</dialog>